// src/pages/LoginPage.jsx
import React from 'react';
import LoginForm from '../components/LoginForm';

function LoginPage() {
  // Функция, которая вызовется из LoginForm, когда пользователь ввёл логин/пароль и нажал «Войти»
  const handleLogin = async (username, password) => {
    try {
      const response = await fetch(process.env.REACT_APP_API_URL + '/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await response.json();
      if (data.success) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('currentUserRole', data.role);

        // после успешного логина делаем редирект на "/"
        window.location.href = '/';
      } else {
        alert('Ошибка входа: ' + data.message);
      }
    } catch (error) {
      console.error('Ошибка при логине:', error);
    }
  };

  return (
    <div>
      <LoginForm onLogin={handleLogin} />
    </div>
  );
}

export default LoginPage;
